import { render } from "./Budget.vue?vue&type=template&id=570ef684&scoped=true"
import script from "./Budget.vue?vue&type=script&lang=js"
export * from "./Budget.vue?vue&type=script&lang=js"

import "./Budget.vue?vue&type=style&index=0&id=570ef684&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570ef684"]])

export default __exports__